var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import { Box, FormControl, InputLabel, Select, MenuItem, IconButton, } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useNotify } from '../../hooks/notificationHook';
import { useRequest } from '../../hooks/requestHook';
import { useRoasterColumns } from '../../hooks/useColumns';
import { useCommunityManagers } from '../../hooks/useCommunityManagers';
import useFetch from '../../hooks/useFetch';
import { roaster as api } from '../../api';
import PageLayout from '../atoms/PageLayout';
import MaterialTable from '../MaterialTable';
import { decamelize } from '../../utils/camelize';
import ManageCommunityManagerButton from '../organisms/ManageCommunityManagerButton';
import DownloadRoastersCSVButton from '../organisms/DownloadRoastersCSVButton';
import BaseButton from '../atoms/BaseButton';
import { format } from 'date-fns';
var AdminRoastersPage = function () {
    var location = useLocation();
    var t = useTranslation().t;
    var notify = useNotify();
    var tableRef = React.useRef();
    var _a = React.useState([]), selectedRoasters = _a[0], setSelectedRoasters = _a[1];
    var _b = React.useState(), selectedCommunityManagerId = _b[0], setSelectedCommunityManagerId = _b[1];
    var _c = React.useState(false), manageCommunityManager = _c[0], setManageCommunityManager = _c[1];
    var communityManagerListItems = useCommunityManagers().communityManagerListItems;
    var _d = React.useState(false), loading = _d[0], setLoading = _d[1];
    var getAll = useRequest(api.getAll);
    var updateCommunityManagers = useRequest(api.updateCommunityManagers);
    var _e = React.useState(), typicaShareRatioCalculatedAt = _e[0], setTypicaShareRatioCalculatedAt = _e[1];
    var query = React.useMemo(function () { return qs.parse(location.search.slice(1)); }, [location]);
    var roasterColumns = useRoasterColumns({
        filters: query.filters,
        orderBy: query.orderBy,
        orderDirection: query.orderDirection,
    });
    var columns = [
        roasterColumns.id,
        roasterColumns.communityManager,
        roasterColumns.customerType,
        roasterColumns.storeType,
        roasterColumns.company,
        roasterColumns.storeName,
        roasterColumns.country,
        roasterColumns.countryOffice,
        roasterColumns.email,
        roasterColumns.countryCallingCode,
        roasterColumns.phone,
        roasterColumns.lastname,
        roasterColumns.firstname,
        roasterColumns.nameKana,
        roasterColumns.postalCode,
        roasterColumns.prefecture,
        roasterColumns.city,
        roasterColumns.address,
        roasterColumns.building,
        roasterColumns.roasterMaker,
        roasterColumns.roasterMaxCapacity,
        roasterColumns.roastedPerMonth,
        roasterColumns.communityEngagement,
        roasterColumns.typicaShareRatio,
        roasterColumns.updatedAt,
        roasterColumns.createdAt,
    ];
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'communityManager':
                    q.community_manager_name_cont = filter.value;
                    break;
                case 'customerType':
                    q.with_customer_type = filter.value;
                    break;
                case 'storeType':
                    q.with_store_type = filter.value;
                    break;
                case 'roasterMaker':
                    q.with_roaster_maker = filter.value;
                    break;
                case 'communityEngagement':
                    q.with_community_engagement = filter.value;
                    break;
                case 'email':
                    q.maintainer_email_cont = filter.value;
                    break;
                case 'id':
                    q.id_eq = filter.value;
                    break;
                case 'country.code':
                    q.country_code_in = filter.value;
                    break;
                case 'country.office.name':
                    q.country_office_name_in = filter.value;
                    break;
                default:
                    if (filter.column.field) {
                        q["".concat(decamelize(filter.column.field), "_cont")] =
                            filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var buildFilterParamsForCSV = React.useCallback(function (filters) {
        return buildFilterParams({
            filters: Object.entries(filters).map(function (_a) {
                var field = _a[0], value = _a[1];
                return ({
                    column: { field: field },
                    operator: '=',
                    value: value,
                });
            }),
        });
    }, [buildFilterParams]);
    var fetchRoasters = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAll,
        onChange: function (_, meta) {
            if (meta['typicaShareRatioCalculatedAt']) {
                var newTypicaShareRatioCalculatedAt = new Date(meta['typicaShareRatioCalculatedAt']);
                if (newTypicaShareRatioCalculatedAt.getTime() !==
                    (typicaShareRatioCalculatedAt === null || typicaShareRatioCalculatedAt === void 0 ? void 0 : typicaShareRatioCalculatedAt.getTime()))
                    setTypicaShareRatioCalculatedAt(newTypicaShareRatioCalculatedAt);
            }
        },
    });
    var reload = React.useCallback(function () {
        if (!tableRef.current)
            return;
        tableRef.current.onQueryChange();
    }, [tableRef]);
    var handleUpdateCommunityManager = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, updateCommunityManagers(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    notify('success', [t('messages.updateSuccess')]);
                    setManageCommunityManager(false);
                    setSelectedRoasters([]);
                    reload();
                    return [2 /*return*/];
            }
        });
    }); }, [t, notify, updateCommunityManagers, reload]);
    var title = React.useMemo(function () { return (React.createElement(Box, null,
        React.createElement(Box, null, t('pages.adminRoasters.title')),
        typicaShareRatioCalculatedAt && (React.createElement(Box, { color: "#888", fontSize: "0.8rem", marginLeft: 1 },
            t('pages.adminRoasters.typicaShareRatioCalculatedAt'),
            ":",
            ' ',
            format(typicaShareRatioCalculatedAt, 'yyyy-MM-dd HH:mm (zzzz)'))))); }, [t, typicaShareRatioCalculatedAt]);
    var csvParams = React.useMemo(function () {
        return query.filters
            ? {
                q: buildFilterParamsForCSV(query.filters),
            }
            : undefined;
    }, [query.filters, buildFilterParamsForCSV]);
    return (React.createElement(PageLayout, { title: title, actions: React.createElement(React.Fragment, null,
            !manageCommunityManager && (React.createElement(ManageCommunityManagerButton, { handleClick: function () { return setManageCommunityManager(true); } })),
            React.createElement(DownloadRoastersCSVButton, { params: csvParams })) },
        React.createElement(MaterialTable, { tableRef: tableRef, title: manageCommunityManager ? t('pages.adminRoasters.title') : undefined, model: "roaster", isLoading: loading, columns: columns, data: fetchRoasters, detailPath: function (roaster) { return "/admin/roasters/".concat(roaster.id); }, options: {
                paging: true,
                filtering: true,
                filterCellStyle: {
                    minWidth: 100,
                },
                selection: manageCommunityManager,
            }, components: {
                Toolbar: function () { return (React.createElement(Box, { p: 4 },
                    React.createElement(FormControl, null,
                        React.createElement(InputLabel, { id: "manageCommunityManagerlabel" }, t('buttons.manageCommunityManager')),
                        React.createElement(Select, { labelId: "manageCommunityManagerlabel", value: selectedCommunityManagerId, onChange: function (event) {
                                return setSelectedCommunityManagerId(event.target.value);
                            }, style: { minWidth: 300 } },
                            React.createElement(MenuItem, { value: "" }, "(blank)"),
                            communityManagerListItems.map(function (_a) {
                                var text = _a.text, value = _a.value;
                                return (React.createElement(MenuItem, { key: value, value: value }, text));
                            }))),
                    ' ',
                    React.createElement(FormControl, null,
                        React.createElement(BaseButton, { type: "submit", onClick: function () {
                                handleUpdateCommunityManager({
                                    community_manager_id: selectedCommunityManagerId,
                                    roaster_ids: selectedRoasters.map(function (_a) {
                                        var id = _a.id;
                                        return id;
                                    }),
                                });
                            } }, t('buttons.apply'))),
                    React.createElement(IconButton, { "aria-label": "close", onClick: function () { return setManageCommunityManager(false); }, sx: { position: 'absolute', right: 8, top: 8 } },
                        React.createElement(CloseIcon, null)))); },
            }, onSelectionChange: function (rows) { return setSelectedRoasters(rows); } })));
};
export default AdminRoastersPage;
